// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__3r9e2","additionalInfo":"AgreementModal_additionalInfo__2gs0z"};